import { Component, Input } from "@angular/core";

@Component({
  selector: "app-skeleton-card",
  template: `
    <div class="flex flex-col gap-4">
      <div
        *ngFor="let _ of rowArr"
        class="rounded-2xl bg-white border border-n30 p-5 flex items-center gap-4 box-shadow-1"
      >
        <div class="skeleton-pulse w-12 h-12 rounded-full flex-shrink-0"></div>
        <div class="flex-1 min-w-0 space-y-2">
          <div class="skeleton-pulse h-3.5 rounded" style="width: 40%"></div>
          <div class="skeleton-pulse h-3 rounded" style="width: 60%"></div>
          <div class="skeleton-pulse h-3 rounded" style="width: 33%"></div>
        </div>
        <div class="flex gap-2 flex-shrink-0">
          <div class="skeleton-pulse w-8 h-8 rounded-full"></div>
          <div class="skeleton-pulse w-8 h-8 rounded-full"></div>
          <div class="skeleton-pulse w-8 h-8 rounded-full"></div>
        </div>
      </div>
    </div>
  `,
})
export class SkeletonCardComponent {
  @Input() rows = 6;
  get rowArr() {
    return Array(this.rows);
  }
}
